/**
 * Page-level loading skeleton for React.lazy + Suspense fallbacks.
 * Shows a professional loading state while chunks download.
 */

import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';

/** Generic page skeleton with header + content area */
export const PageSkeleton: React.FC = () => (
  <Box sx={{ p: 3 }}>
    <Skeleton variant="text" width={240} height={40} sx={{ mb: 2 }} />
    <Grid container spacing={3}>
      {[1, 2, 3, 4].map(i => (
        <Grid item xs={12} sm={6} lg={3} key={i}>
          <Skeleton variant="rectangular" height={120} sx={{ borderRadius: 1 }} />
        </Grid>
      ))}
    </Grid>
    <Skeleton variant="rectangular" height={400} sx={{ mt: 3, borderRadius: 1 }} />
  </Box>
);

/** Dashboard-specific skeleton with chart placeholder */
export const DashboardSkeleton: React.FC = () => (
  <Box sx={{ p: 3 }}>
    <Skeleton variant="text" width={200} height={36} sx={{ mb: 2 }} />
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {[1, 2, 3, 4].map(i => (
        <Grid item xs={12} sm={6} md={3} key={i}>
          <Skeleton variant="rectangular" height={100} sx={{ borderRadius: 1 }} />
        </Grid>
      ))}
    </Grid>
    <Grid container spacing={2}>
      <Grid item xs={12} md={8}>
        <Skeleton variant="rectangular" height={350} sx={{ borderRadius: 1 }} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Skeleton variant="rectangular" height={350} sx={{ borderRadius: 1 }} />
      </Grid>
    </Grid>
  </Box>
);

/** Table-focused skeleton */
export const TableSkeleton: React.FC = () => (
  <Box sx={{ p: 3 }}>
    <Skeleton variant="text" width={200} height={36} sx={{ mb: 2 }} />
    <Skeleton variant="rectangular" height={48} sx={{ mb: 1, borderRadius: 1 }} />
    {[1, 2, 3, 4, 5, 6].map(i => (
      <Skeleton key={i} variant="rectangular" height={52} sx={{ mb: 0.5, borderRadius: 0.5 }} />
    ))}
  </Box>
);

export default PageSkeleton;
